// Footer.jsx
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="footer-top-pattern"></div>
      
      <footer className="footer">
        <div className="footer-content">
          {/* Main Section */}
          <div className="footer-main">
            <div className="footer-section brand-section">
              <h3>Digital Business Transformation</h3>
              <p>Transform your business in order to survive in a completely digitized and 
                 connected world driven by Genie Marketplace.</p>
            </div>

            <div className="footer-section features">
              <div className="feature-item">
                <h4>Web Scale</h4>
                <p>Globally scale app with innovative content management and infrastructure approaches.</p>
              </div>
              
              <div className="feature-item">
                <h4>Omni-Channel Engagement</h4>
                <p>Content-focused web and mobile solution for empowering vendors.</p>
              </div>
              
              <div className="feature-item">
                <h4>Enterprise Mobility</h4>
                <p>Faster tailored mobile experiences for any device and data source.</p>
              </div>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer-links-section">
            <div className="links-column">
              <h4>QUICK LINKS</h4>
              <ul>
                <li><a href="#">Products</a></li>
                <li><a href="#">Partners</a></li>
                <li><a href="#">Support</a></li>
                <li><a href="#">Training</a></li>
                <li><a href="#">Consulting</a></li>
                <li><a href="#">Blogs</a></li>
              </ul>
            </div>

            <div className="links-column">
              <h4>ABOUT</h4>
              <ul>
                <li><a href="#">Customers</a></li>
                <li><a href="#">Investor Relations</a></li>
                <li><a href="#">Offices</a></li>
                <li><a href="#">Careers</a></li>
              </ul>
            </div>

            <div className="contact-column">
              <h4>CONTACT US</h4>
              <a href="tel:+233-50-156-6333" className="phone-number">
                <i className="fas fa-phone-alt" style={{ marginRight: '10px' }}></i>
                +233-50-156-6333
              </a>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-logo-section">
              <img src="/assets/genie.png" alt="Genie logo" className="footer-logo" />
            </div>
            
            <div className="footer-legal">
              <div className="legal-links">
                <a href="#">Terms of Use</a>
                <a href="#">Privacy Policy</a>
                <a href="#">Trademarks</a>
                <a href="#">License Agreements</a>
              </div>
              <p className="copyright">Copyright © 2024 Genie Marketplace. All rights reserved.</p>
            </div>

            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
              <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;